import React from "react";
import { LetterOfAuthorization, Header, Subheader, LetterContent, InstructionList,InstructionSubList, ContributionSubList, OwnerAuthority, VanguardRepresentative, SignGurantee, FormInput, AuthorizedOffice, Mail, Email, Fax, Guildelines, AboutVanguard, Print, LetterWrapper,FontBoldText,AuthorizationText } from "./styles";
import logo from '../../../../../../../../assets/icons/vcep-logo.png';
import printIcon from "../../../../../../../../assets/icons/print.svg";
import PrintComponents from "react-print-components";
import { StyleLessButton } from "../../../../../../../../CommonComponents/commonStyles";
import { IconPadding,DataExportPrint } from "../../../../styles";
import { removeHeaderFooter } from "../../../../utils";
import moment from "moment";
let assetMF = [];

export class ViewContribution extends React.Component {

    componentDidMount = () => {
        removeHeaderFooter();
    }

    componentWillUnmount = () => {
        localStorage["assetMF"] = "";
    }

    renderPrintData = () => {
        return (
        <LetterOfAuthorization>
            <img src={logo} alt="vanguard"></img>
            <Header>Letter of authorization</Header>
            <Subheader>Online contribution of Vanguard mutual fund shares held at The Vanguard Group Inc. (Vanguard) and/or
            Vanguard Brokerage Services (VBS)</Subheader>
            <LetterContent>
                Please note, this contribution cannot be processed until this form is received by
                Vanguard Charitable. All registered owners of the assets to be donated must sign in
                Section 4. If the aggregate value of this contribution is <FontBoldText>more than $2 million,</FontBoldText> the
                form requires further authentication such as Vanguard Voice verification<sup>TM</sup>, Signature
                guarantee, or Medallion signature guarantee. If so, do not sign the form until you are
                in the presence of the officer.
            </LetterContent>
            <InstructionList>
                <li>
                    Funding instructions
                    <InstructionSubList type="A">
                        <li>
                            Verify the pre-populated information and complete any additional information. Print out your
                            completed <AuthorizationText>Letter of authorization</AuthorizationText> and have it signed by all registered owners of the assets
                            being donated.
                        </li>
                        <li>
                            If the aggregate value is greater than $2 million, obtain additional authentication in the form of
                            Vanguard voice verification, Signature guarantee, or Medallion signature guarantee. For more
                            information, visit vanguardcharitable.org/authenticate.
                        </li>
                        <li>
                            Vanguard uses the average cost method as its default method for mutual funds. Vanguard will
                            use either the default cost basis method (of average cost) or the preferred cost basis method
                            you selected. If your cost basis method is specific ID and you would like to gift a specific lot
                            of shares, complete lot identification in <FontBoldText>Section 3-C</FontBoldText> below. For more information about
                            specifying cost basis, please visit vanguardcharitable.org/costbasis.
                        </li>
                    </InstructionSubList>
                </li>
                <li>
                    Vanguard Charitable account information
                    <div>Account number: { assetMF[0].logAcNum }</div>
                    <div>Account name: { assetMF[0].logAcName }</div>
                </li>
                <li>
                    Contribution instructions
                    <ContributionSubList type="A">
                        <li>To Vanguard and/or VBS:
                            <span>&nbsp;Your client is authorizing the transfer of ownership to Vanguard
                                Charitable of either shares of Vanguard mutual funds or funds available in the settlement fund
                                of the account specified below. <FontBoldText>Vanguard mutual fund shares should be transferred in-
                                kind and are not to be liquidated, only Vanguard brokerage settlement fund shares will
                                be liquidated and transferred as cash.</FontBoldText>
                            </span>
                        </li>
                        <li>Registration:
                            <span>&nbsp;{assetMF[0].type !== "Joint" ? assetMF[0].donorName : (assetMF[0].firstName + ' ' +  assetMF[0].lastName)}</span>
                        </li>
                        <li>
                            Delivery instructions
                            <div>Contribution from Vanguard and/or VBS account number: {assetMF[0].accountNumber}</div>
                            <table className="center" border="1">
                                <thead>
                                    <tr>
                                        <th>Mutual fund name</th>
                                        <th>Ticker symbol</th>
                                        <th>Fund number</th>
                                        <th>Shares</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {assetMF.map((fund) => (
                                    <tr>
                                    <td>{fund.fundName}</td>
                                    <td>{fund.ticker}</td>
                                    <td>{fund.fundNumber}</td>
                                    <td>{fund.shares ? fund.shares : (fund.allShares ? 'All Shares' : fund.shares)}</td>
                                </tr>
                                ))}
                                </tbody>
                            </table>
                            <div>Specific ID: If the cost basis method for your account is recorded as Specific ID, and you wish to specify lots, complete
                                the fields below.</div>
                            <table border="1">
                                <thead>
                                    <tr>
                                        <th>Account number</th>
                                        <th>Fund name</th>
                                        <th>Ticker symbol</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                </tbody>
                            </table>
                            <table border="1">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Number of shares</th>
                                        <th>Date shares acquired</th>
                                        <th>Purchase price per share</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>Lot 1</td>
                                        <td></td>
                                        <td></td>
                                        <td>$</td>
                                    </tr>
                                    <tr>
                                        <td>Lot 2</td>
                                        <td></td>
                                        <td></td>
                                        <td>$</td>
                                    </tr>
                                    <tr>
                                        <td>Lot 3</td>
                                        <td></td>
                                        <td></td>
                                        <td>$</td>
                                    </tr>
                                </tbody>
                            </table>
                        </li>
                    </ContributionSubList>
                </li>
                <li>
                    Signatures: This section must be signed by all registered owners/trustees/officers of the assets to be donated.
                    <div className="mt-05">I/We authorize Vanguard and/or VBS to transfer the shares I/we hold in the Vanguard and/or VBS
                        account specified in Section 3 of this form to a Vanguard Charitable account. I/We hereby irrevocably
                        relinquish all rights, title, and interest to the shares specified in Section 3 to Vanguard Charitable, and
                        understand that by requesting this transfer, I/we will be giving up full rights, ownership and any and all
                        claims to the shares. I/We hereby acknowledge that I/we previously received from Vanguard Charitable
                        information about the terms of the transfer, and I/we have read, understand and acknowledge those
                        terms, including the fact that the terms of this transfer are binding regardless of any other agreement
                        I/we have with Vanguard Charitable.
                    </div>
                    <div className="mt-05">
                        For trustees: By signing below, I/we certify that I/we have the power and authority under the trust
                        agreement and applicable law to give this authorization.
                    </div>
                    <OwnerAuthority>
                        <div>Owner A</div>
                        <div>Owner's name: {(assetMF[0].type === "Joint" || assetMF[0].type === "Individual") ? (assetMF[0].name): assetMF[0].donorName}</div>
                        <div>
                            <div>
                                <label>Signature:</label>
                                <input type="text"></input>
                            </div>
                            <div>
                                <label>Date(mm-dd-yyyy):</label>
                                <input type="text"></input>
                            </div>
                        </div>
                    </OwnerAuthority>
                    { assetMF[0].type !== "Individual" ?
                    <OwnerAuthority>
                        <div>Owner B</div>
                        <div>Owner's name: { assetMF[0].type !== "Joint" ? assetMF[0].donorName : (assetMF[0].firstName + ' ' +  assetMF[0].lastName)}</div>
                        <div>
                            <div>
                                <label>Signature:</label>
                                <input type="text"></input>
                            </div>
                            <div>
                                <label>Date(mm-dd-yyyy):</label>
                                <input type="text"></input>
                            </div>
                        </div>
                    </OwnerAuthority>
                    : '' }
                    <div className="mt-10">
                        <AuthorizationText >If the aggregate value of the contribution is greater than $2 million, you must obtain additional
                        authentication. For more information visit: vanguardcharitable.org/authenticate.</AuthorizationText>
                    </div>
                    <VanguardRepresentative>
                        <div>
                            <input type="checkbox"></input>
                            <span>Check this box if you intend to use Vanguard voice
                                    verification in lieu of signature guarantee. However,
                                    you must be enrolled in the service, which can take
                                    up to one week to complete. For more information
                                    or to register, contact your Vanguard representative.
                            </span>
                        </div>
                        <div>
                            <p>Name of Vanguard representative (if known):</p>
                            <input type="text"></input>
                        </div>
                    </VanguardRepresentative>
                    <SignGurantee>
                        <FontBoldText>Signature guarantee or Medallion signature guarantee - IF REQUIRED</FontBoldText>
                        <div>A notary public cannot provide a signature guarantee.</div>
                        <FormInput>
                            <label>Signature of authorized officer:</label>
                            <input type="text"></input>
                        </FormInput>
                        <FormInput>
                            <label>Name of institution:</label>
                            <input type="text"></input>
                        </FormInput>
                        <FormInput>
                            <label>Title:</label>
                            <input type="text"></input>
                        </FormInput>
                        <FormInput>
                            <label>Date:</label>
                            <input type="text"></input>
                        </FormInput>
                        <AuthorizedOffice>
                            <div>
                                Authorized officer to place stamp here.
                            </div>
                            <div>
                                This applies to all signatures in Section 4.
                            </div> 
                        </AuthorizedOffice>
                    </SignGurantee>
                </li>
                <li>Return information
                    <div>
                        Return this completed form to Vanguard Charitable via mail, email, or fax. If a Medallion signature
                        guarantee is required, this form must be mailed to Vanguard Charitable.
                    </div>
                    <Mail>Mail: <span>Vanguard Charitable, P.O. Box 9509, Warwick, RI 02889-9509</span></Mail>
                    <Email>Email: <span>donorservice@vanguardcharitable.org</span></Email>
                    <div>
                        Documents should be encrypted and password should be sent separately. Contact Vanguard Charitable
                        for assistance if necessary.
                    </div>
                    <Fax>Fax: <span>866-485-9414</span></Fax>
                </li>
            </InstructionList>
            <Guildelines>
                If applicable, Vanguard Charitable will send a tax substantiation letter once the contribution is processed.
                For more information, view our <a href={assetMF[0].envURL + "/company-policies/policies-and-guidelines"} target="_blank">
                <span>Policies and guidelines</span></a> booklet.
            </Guildelines>
            <AboutVanguard>
                Vanguard Charitable was founded by The Vanguard Group, Inc. as an independent, nonprofit, public
                charity in 1997. Although Vanguard provides certain investment management and administrative services
                to Vanguard Charitable pursuant to a service agreement, Vanguard Charitable is not a program or activity
                of Vanguard. A majority of Vanguard Charitable's Trustees are independent of Vanguard.
            </AboutVanguard>
            <AboutVanguard>© {moment().format('YYYY')} Vanguard Charitable Endowment Program. All rights reserved.</AboutVanguard>
        </LetterOfAuthorization>  
        )
    }

    render() {
        assetMF = [];
        assetMF = JSON.parse(localStorage["assetMF"]);
        return (
                     <LetterWrapper> 
                     <PrintComponents
                        className="i_print"
                        trigger={
                          <Print>
                          <StyleLessButton>
                            <IconPadding className="ml2">
                              <img src={printIcon} alt="print"/>
                              <DataExportPrint>PRINT</DataExportPrint>
                            </IconPadding>
                          </StyleLessButton>
                          </Print>
                        } >
                            {this.renderPrintData()}
                        </PrintComponents>
                     {this.renderPrintData()}</LetterWrapper>
            );
                
    }
}

export default ViewContribution;


